// extracted by mini-css-extract-plugin
export default {"title":"SurveyForm_title__TCL11","form-container":"SurveyForm_form-container__fNHBZ","input-box":"SurveyForm_input-box__gC0MO"};